export default {
    init: function () {
        checkAnimate();

        $(window).on('load scroll', function () {
            checkAnimate();
        });

        function isElementInViewport(element) {
            const rect = element[0].getBoundingClientRect();
            const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
            const percentVisible = 70;

            return !(
                Math.floor(100 - (((rect.top >= 0 ? 0 : rect.top) / +-(rect.height)) * 100)) < percentVisible ||
                Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) < percentVisible
            );
        }

        function animateLine(path) {
            // const path = document.getElementById(pathId);
            var length = path.getTotalLength();
            // Clear any previous transition
            path.style.transition = path.style.WebkitTransition =
                'none';
            // Set up the starting positions
            path.style.strokeDasharray = length + ' ' + length;
            path.style.strokeDashoffset = length;
            // Trigger a layout so styles are calculated & the browser
            // picks up the starting position before animating
            path.getBoundingClientRect();
            // Define our transition
            path.style.transition = path.style.WebkitTransition =
                'stroke-dashoffset 4s ease-in-out';
            // Go!
            path.style.strokeDashoffset = '0';
            setTimeout(() => {
                $(path).removeClass('animating');
            }, 6000);
        }

        function checkAnimate() {
            $('.animated-icon-path').each(function () {
                if (isElementInViewport($(this))) {
                    if (!$(this).hasClass('animating')) {
                        $(this).addClass('animating');
                        animateLine(this);
                    }
                }
            });
        }
    }
};
